import React, { useRef, useState } from 'react';
import styles from './CheckboxFilter.module.css';
import clx from '../../common/clx';
import Popover from '../../common/Popover';
import Ico from '../../common/Ico';

const ICO_CHEVDOWN = 'm6 9 6 6 6-6';
const ICO_CHECK    = 'M20 6 9 17l-5-5';

/** Multi-select checklist filter. An empty `selected` set means "no filter applied". */
export default function CheckboxFilter({ label, options, selected, onChange }) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const isActive = selected.size > 0;
  const toggle = (value) => {
    const next = new Set(selected);
    if (next.has(value)) next.delete(value); else next.add(value);
    onChange(next);
  };

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className={clx(styles.trigger, isActive && styles.triggerActive)}
        onClick={() => setOpen((o) => !o)}
      >
        {label}{isActive ? ` · ${selected.size}` : ''}
        <Ico d={ICO_CHEVDOWN} size={12} className={styles.triggerChev} />
      </button>

      <Popover anchorRef={anchorRef} open={open} onClose={() => setOpen(false)} minWidth={180}>
        <div className={styles.list}>
          {options.map((opt) => {
            const checked = selected.has(opt.value);
            return (
              <button
                key={opt.value}
                type="button"
                className={styles.row}
                onClick={() => toggle(opt.value)}
              >
                <span className={clx(styles.checkbox, checked && styles.checkboxChecked)}>
                  {checked && <Ico d={ICO_CHECK} size={10} strokeWidth={2.6} />}
                </span>
                <span className={styles.rowLabel}>{opt.label}</span>
                {opt.count != null && <span className={styles.rowCount}>{opt.count}</span>}
              </button>
            );
          })}
        </div>
        {isActive && (
          <div className={styles.footer}>
            <button type="button" className={styles.clearBtn} onClick={() => onChange(new Set())}>
              Clear filter
            </button>
          </div>
        )}
      </Popover>
    </>
  );
}
